import Seo from "@/components/Seo";

export default function LegalLayout({ title, subtitle, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-white" data-testid={testId}>
      <Seo title={title} description={subtitle} />
      <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-20">
        <div className="mb-10 pb-8 border-b border-slate-200">
          <span className="inline-block text-[10px] tracking-[0.18em] text-slate-400 font-semibold uppercase mb-3">
            // CARTONOMIE
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-slate-600 leading-relaxed">{subtitle}</p>
          )}
          {lastUpdated && (
            <p className="text-[11px] text-slate-400 mt-4 uppercase tracking-wider">
              {lastUpdated}
            </p>
          )}
        </div>
        <article className="prose-legal text-sm text-slate-700 leading-relaxed space-y-6">
          {children}
        </article>
      </div>
    </div>
  );
}
